const createSignalRHubsManager = () => {
  const hubs = [];

  function addHub(hubName, instance) {
    hubs[hubName] = instance;
  }

  function getHub(hubName) {
    return hubs[hubName];
  }

  return {addHub, getHub};
};

const SignalRHubs = createSignalRHubsManager();

export default SignalRHubs;
